import classNames from 'classnames';
import React, { PureComponent } from 'react';

class FlexLayoutBox extends PureComponent<any> {
  render() {
    const { className, header, secondaryHeader, children, testid, noBodyPadding } = this.props;

    const fullHeader = secondaryHeader ? (
      <div className="flex-layout__box-header-with-secondary">
        <div>{header}</div>
        <div className="h_mstart-a">{secondaryHeader}</div>
      </div>
    ) : (
      <div className="flex-layout__box-header">{header}</div>
    );

    /*
		In order to guarantee that passing in a class will overwrite the flex defaults, we had to have these defaults as a separate class that is only applied if the user does NOT pass in a class. We want the styling applied to all boxes consistently however, so this is separately applied to all box divs.
		*/
    return (
      <div
        data-testid={testid}
        className={classNames('flex-layout__box-styling', {
          [className]: !!className,
          'flex-layout__box-flex-default': !className,
        })}
      >
        {header ? fullHeader : null}
        <div className={classNames({ 'h_p-20': !noBodyPadding })}>{children}</div>
      </div>
    );
  }
}

// NOTE: Must be used as child of FlexLayoutContainer to work properly.

export default FlexLayoutBox;
